import React, { useState, createContext, useContext, useEffect } from 'react';
import { App, Application } from '../../firestore_model';
import { useAuthUser } from '../';
import { Utils } from '../../../common/helper';
export const _ = () => {
    const [state, setState] = useState({ loading: true });
    const { user } = useAuthUser();
    useEffect(() => {
        let enabled = true;
        const f = async () => {
            try {
                if (enabled) {
                    setState({ loading: false });
                }
                const applyClinicMaster = await Application.Master.get(Application.Master.documentId);
                let master;
                let paymentMaster;
                if (Utils.isNotNull(user)) {
                    master = await App.Master.get(App.Master.documentId);
                    paymentMaster = await App.PaymentMaster.get(App.PaymentMaster.documentId);
                }
                if (enabled) {
                    setState({ master: master, paymentMaster, applyClinicMaster: applyClinicMaster, loading: false });
                }
            }
            catch (e) {
                console.error(e);
                if (enabled) {
                    setState({ loading: false, error: e });
                }
            }
        };
        f();
        return () => {
            enabled = false;
        };
    }, [user]);
    return {
        master: state.master,
        paymentMaster: state.paymentMaster,
        applyClinicMaster: state.applyClinicMaster,
        loading: state.loading,
        error: state.error,
    };
};
export const MasterContext = createContext({ loading: false });
export const MasterProvider = ({ children }) => {
    const { master, paymentMaster, applyClinicMaster, loading, error } = _();
    return (React.createElement(MasterContext.Provider, { value: {
            master,
            paymentMaster,
            applyClinicMaster,
            loading,
            error,
        } }, children));
};
export const useMaster = () => useContext(MasterContext);
